
import dashboard from './dashboard'
import views from './views'

export default [...dashboard, ...views]
